import { useQuery } from "@tanstack/react-query";

import { useDataApi } from "@core/apis";

import { getFlexStationEventLogOptions } from "../queries";

/**
 * Fetch a flexstation's event log through the ISharedDataApi boundary.
 *
 * Input-driven: the caller supplies the already-resolved `flexStationUid`
 * (platform-web passes `station.subUid`; propai-web resolves it from the
 * substation via `usePropAiFlexStationEventLog`). No PropAI-specific lookup
 * lives here. `networkUid` is only used by the platform network-scoped endpoint.
 */
export const useFlexStationEventLog = (args: {
  substationUid?: string;
  flexStationUid?: string;
  networkUid?: string;
}) => {
  const dataApi = useDataApi();
  return useQuery(
    getFlexStationEventLogOptions(dataApi, args.substationUid, args.flexStationUid, args.networkUid)
  );
};
